import { IDevicesContext, IFilterValues } from './devicesContext';

export enum DevicesActionTypes {
	SET_DEVICES = 'SET_DEVICES',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_DEVICE_ID_FOR_DELETION = 'SET_DEVICE_ID_FOR_DELETION',
	SET_DEVICE_ID_FOR_FULL_INFO = 'SET_DEVICE_ID_FOR_FULL_INFO',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface ISetDevices {
	type: DevicesActionTypes.SET_DEVICES;
	payload: {
		devices: IDevicesContext['devices'];
		typeOfModalWindow: IDevicesContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: DevicesActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IDevicesContext['searchString'];
	};
}

interface ISetIDCustomer {
	type: DevicesActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IDevicesContext['IDSelectedCustomer'];
	};
}

interface ISetIDRestaurant {
	type: DevicesActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IDevicesContext['IDSelectedRestaurant'];
	};
}

interface IResetSelectedControls {
	type: DevicesActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: DevicesActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IDevicesContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: DevicesActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IDevicesContext['countOfItems'];
	};
}

interface ISetCurrentPage {
	type: DevicesActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IDevicesContext['currentPage'];
	};
}

interface ISetDeviceIDForDeletion {
	type: DevicesActionTypes.SET_DEVICE_ID_FOR_DELETION;
	payload: {
		deviceIDForDeletion: IDevicesContext['deviceIDForDeletion'];
		typeOfModalWindow: IDevicesContext['typeOfModalWindow'];
	};
}

interface ISetDeviceIDForFullInfo {
	type: DevicesActionTypes.SET_DEVICE_ID_FOR_FULL_INFO;
	payload: {
		deviceIDForFullInfo: IDevicesContext['deviceIDForFullInfo'];
	};
}

interface IChangeTypeOfModalWindow {
	type: DevicesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IDevicesContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: DevicesActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TDevicesActions =
	| ISetDevices
	| IChangeSearchString
	| ISetIDCustomer
	| ISetIDRestaurant
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| ISetCurrentPage
	| ISetDeviceIDForDeletion
	| ISetDeviceIDForFullInfo
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
